import { render, staticRenderFns } from "./buysellhistory.vue?vue&type=template&id=292e06be&"
import script from "./buysellhistory.vue?vue&type=script&lang=js&"
export * from "./buysellhistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports